import script from "./StrategyAuthAdd.vue?vue&type=script&lang=ts&setup=true"
export * from "./StrategyAuthAdd.vue?vue&type=script&lang=ts&setup=true"

import "./StrategyAuthAdd.vue?vue&type=style&index=0&id=5f682472&lang=scss"

const __exports__ = script;

export default __exports__